import { render, staticRenderFns } from "./SummaryOrder.vue?vue&type=template&id=5d918566&scoped=true"
import script from "./SummaryOrder.vue?vue&type=script&lang=ts"
export * from "./SummaryOrder.vue?vue&type=script&lang=ts"
import style0 from "./SummaryOrder.vue?vue&type=style&index=0&id=5d918566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d918566",
  null
  
)

export default component.exports